import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-diagnosis-filter-unfinished",
  "use": "app-icon-diagnosis-filter-unfinished-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-diagnosis-filter-unfinished\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"7.25\" stroke=\"currentColor\" stroke-width=\"1.5\" /><path fill=\"currentColor\" d=\"M4 7h8v2H4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol